export const WIDGET_HEIGHT = 500
export const WIDGET_WIDTH = 350
export const COLLAPSED_HEIGHT = 60
export const COLLAPSED_WIDTH = 200
